import axios from 'axios';
import History from '../history';
import Observer from '../../common/scripts/observer';
import ParametricFilter from './templates/filter';
import ParametricResult from './templates/result';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

/**
 * 🚩🚩🚩🔴🔴🔴 - RED FLAG 🔴🔴🔴🚩🚩🚩
 * Не делать этот код донором параметрического поиска других проектов без полного рефакторинга
 */
class Parametric {
    constructor(options) {
        this.options = options;
        this.element = options.element;

        this.filter = null;
        this.result = null;

        this.getParams = new URLSearchParams();
    }

    init() {
        this._initFilter();
        this._initResult();
    }

    /**
     * Инициализация фильтров
     * @private
     */
    _initFilter() {
        this.filter = new ParametricFilter({
            element: this.element,
            change : (reqType, addData) => {
                this._send(reqType, addData);
            },
            updateFilterGroupCheckbox: (state) => {
                this.result.setResultGroupCheckboxState(state);
            }
        });

        this.filter.init();
    }

    /**
     * Инициализация результатов
     * @private
     */
    _initResult() {
        this.result = new ParametricResult({
            element   : this.element,
            changeSort: (data) => {
                this._send('sort', data);
            },
            clickMore: (data) => {
                this._send('more', data);
            },
            changeGroup: (data) => {
                this._send('filter', data);
            },
            changeGroupInfo: (data) => {
                this._send('groupInfo', data);
            },
            onDiscountChange: (value) => {
                this.filter.setDiscountValue(value);
            },

            updateFilterGroupCheckbox: (state) => {
                this.filter.setResultGroupCheckboxState(state);
            },
            setActiveFilter: () => {
                this.filter.setDisable(false);
            }
        });

        this.result.init();
    }

    _initSelectActions(formData, getParamsData) {
        const parametric = document.querySelector('.parametric');

        if (!parametric) {
            return;
        }

        const selectActions = parametric.querySelectorAll('.j-parametric__select_action-checkbox');

        if (!selectActions) {
            return;
        }

        selectActions.forEach((act) => {
            const name = act.getAttribute('name');
            const val = act.getAttribute('value');

            if (act.checked) {
                formData.append(name, val);
                getParamsData.append(name, val);
            }
            if (!act.checked) {
                formData.delete(name);
                getParamsData.delete(name);
            }
        });
    }

    /**
     * Запрос на сервер
     * @param {string} reqType - тип запроса
     * @param {object} additionalData - дополнительные данные
     * @private
     */
    /* eslint-disable max-lines-per-function, max-statements */
    _send(reqType, additionalData = {}) {
        const form = this.filter.getForm();
        const formData = form && Utils.isElement(form) ? new FormData(form) : new FormData();
        // Объект для вставки параметров в урл
        const getParamsData = new FormData();

        // Удаляет пустые данные
        for (const [key, value] of formData) {
            if (value === '') {
                formData.delete(key);
            }
        }

        for (const pair of formData.entries()) {
            getParamsData.append(pair[0], pair[1]);
        }


        // Удаляет скрытые инпуты из гет параметров
        for (const [key] of Array.from(getParamsData.entries())) {
            const input = this.element.querySelector(`input[name="${key}"]`);

            if (input && input.type === 'hidden') {
                getParamsData.delete(key);
            }
        }

        this._initSelectActions(formData, getParamsData);

        this.getParams = new URLSearchParams(getParamsData);

        if (!Utils.isElement(form)) {
            const exact = ['action', 'method'];

            for (const key in form) {
                if (Object.prototype.hasOwnProperty.call(form, key) && exact.indexOf(key) === -1) {
                    formData.append(key, form[key]);
                }
            }
        }

        this._addAdditionalData(formData, additionalData);
        this.filter.convertRanges(formData);
        this.filter.convertRanges(getParamsData);

        // Действия перед отправкой запроса
        this._switchByReqType(reqType, getParamsData);

        formData.append('request_type', reqType);

        // Hidden params
        formData.append('ts', form.dataset.appendTs || '');
        formData.append('st', form.dataset.appendSt || '');
        formData.append('mf', form.dataset.appendMf || '');

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios[form.method](form.action, formData)
            .then((response) => {
                const {data, success, messages} = response.data;

                if (!success) {
                    throw new Error(messages.length ? messages : 'Ошибка на сервере');
                }

                data.isGroup = formData.get('group');
                data.isSortGroup = formData.get('sortGroup');

                this._switchOnSend(reqType, data);
            })
            .catch((error) => {
                console.error(error);
            })
            .then(() => {
                this.filter.stopLoading();
                this.result.stopLoading();
            });
    }
    /* eslint-enable max-lines-per-function, max-statements */

    _switchByReqType(reqType, getParamsData) {
        switch (reqType) {
            case 'filter':
                this._resetUrl();
                this.filter.runLoading(true);
                this.result.runLoading();
                History.appendFromFormData(getParamsData);
                break;
            case 'reset':
                this._resetUrl();
                this.filter.runLoading(true);
                break;
            case 'sort':
                this.result.runLoading();
                History.appendFromFormData(getParamsData);
                break;
            case 'more':
                this.result.runLoading(true);
                break;
            case 'groupInfo':
                this._resetUrl();
                this.result.runLoading();
                History.appendFromFormData(getParamsData);
                break;
            default:
                break;
        }
    }

    /* eslint-disable max-lines-per-function, max-statements */
    _switchOnSend(reqType, data) {
        switch (reqType) {
            case 'sort':
                this.result.setSortResult(data);
                if (data.isGroup) {
                    this.result.reInitGroupElements();
                }
                this.result.setMoreButton(data?.more);
                this.result.setTagsHideCount();
                observer.publish('popup:refresh');
                observer.publish('favorite:reInit');
                observer.publish('compare:reInit');
                break;
            case 'more':
                this.result.setMoreResult(data);
                if (data.isGroup) {
                    this.result.reInitGroupElements();
                }
                this.result.setTagsHideCount();
                observer.publish('popup:refresh');
                observer.publish('favorite:reInit');
                observer.publish('compare:reInit');
                break;
            case 'filter':
                this.filter.setFilter(data, reqType);
                this.result.setResult(data);
                if (this.checkHasFlats(data) && this.checkHasRedirect(data)) {
                    // console.log(1111);
                    const basePath = window.location.pathname;

                    this.replaceUrl(data.redirect);

                    if (basePath !== data.redirect.redirect_to_raw) {
                        window.location.reload();
                    }
                }
                this.result.showMoreFlatInfo();
                if (data.isGroup) {
                    this.result.reInitGroupElements();
                }
                this.result.setTagsHideCount();
                observer.publish('popup:refresh');
                observer.publish('favorite:reInit');
                observer.publish('compare:reInit');
                break;
            case 'reset':
                this.filter.setFilter(data, reqType);
                this.result.setResult(data);
                if (this.checkHasFlats(data) && this.checkHasDefaultRedirect(data)) {
                    this.replaceUrl(data.default_redirect);
                    window.location.reload();
                }
                if (data.isGroup) {
                    this.result.reInitGroupElements();
                }
                this.result.showMoreFlatInfo();
                this.result.setTagsHideCount();
                observer.publish('parametric:filterReset');
                observer.publish('popup:refresh');
                observer.publish('favorite:reInit');
                observer.publish('compare:reInit');
                break;
            case 'groupInfo':
                if (data.isSortGroup) {
                    this.result.setGroupFlatsList(data, true);
                } else {
                    this.result.setResultGroupInfo(data);
                    this.result.initGroupSortSelect();
                    this.filter.setDisable(true);
                }
                this.result.showMoreFlatInfo();
                this.result.backToGroup();
                this.result.setTagsHideCount();
                observer.publish('popup:refresh');
                observer.publish('favorite:reInit');
                observer.publish('compare:reInit');
                break;
            default:
                break;
        }
    }
    /* eslint-enable max-lines-per-function, max-statements */

    checkHasInData(data, key) {
        return Object.keys(data).includes(key);
    }

    checkHasFlats(data) {
        return this.checkHasInData(data, 'flats');
    }

    checkHasRedirect(data) {
        return this.checkHasInData(data, 'default_redirect');
    }

    checkHasDefaultRedirect(data) {
        return this.checkHasInData(data, 'default_redirect');
    }

    replaceUrl(redirect) {
        if (typeof redirect !== 'undefined') {
            History.setUrl(redirect.redirect_to);
        }
    }

    /**
     * Добавляет дополнительные данные в данные формы
     * @param {object} formData - formData
     * @param {object} data - объект доп. данных (может содержать данные формы)
     * @private
     */
    _addAdditionalData(formData, data) {
        if (!data) {
            return;
        }

        Object.keys(data).forEach((key) => {
            if (data[key] instanceof FormData) {
                data[key].forEach((v, k) => {
                    formData.append(k, v);
                });
            } else if (data[key] instanceof Array) {
                data[key].forEach((el) => {
                    formData.append(key, el);
                });
            } else {
                formData.append(key, data[key]);
            }
        });
    }

    /**
     * Очищает url от параметров
     * @private
     */
    _resetUrl() {
        History.clear();
    }
}

export default Parametric;
